import axios from "axios";
import ApiService from "@/services/ApiService.js";

export const state = {
  sentido_selected: {}, //seleccionara el objeto de la lista de magistrados
  sentidos: []
};
export const mutations = {
  SELECT_SENTIDO({ context }, sentido) {
    return (state.sentido_selected = Object.assign({}, sentido));
  },
  FILL_SENTIDO({ context }, list_sentidos) {
    let sentidos = [];
    Object.entries(list_sentidos).forEach(([key, val]) => sentidos.push(val));
    return (state.sentidos = sentidos);
  }
};
export const actions = {
  GET_ALL_SENTIDOS({ commit }, data) {
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true); //este loadin esta en el index principalde store
      ApiService.get(data)
        .then(response => {
          commit("SET_LOADING", false);
          commit("CLEAR_NOTIFICATION");
          commit("FILL_SENTIDO", response.data.data.sentidos);
          commit("SET_NOTIFICATION", {
            type: "success",
            message: response.data.message
          });
          resolve(response);
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  SAVE_SENTIDO({ commit }, data) {
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true); //este loadin esta en el index principalde store
      ApiService.post(data)
        .then(response => {
          commit("CLEAR_NOTIFICATION");
          resolve(response);
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  EDIT_SENTIDO({ commit }, data) {
  return new Promise((resolve, reject) => {
    commit("SET_LOADING", true); //este loadin esta en el index principalde store
    ApiService.put(data)
      .then(response => {
        commit("CLEAR_NOTIFICATION");
        resolve(response);
      })
      .catch(error => {
        console.log(error);
        reject(error);
      });
  });
},
  DELETE_SENTIDO({ commit }, data) {
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true); //este loadin esta en el index principalde store
      ApiService.delete(data)
        .then(response => {
          commit("CLEAR_NOTIFICATION");
          resolve(response);
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
};
export const getters = {
  getAllSentidos: state => {
    return state.sentidos;
  }
};
